// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import filterReducer from './filterslice';
import appointmentinfo from './orders/appinfo';
import universalsearcherReducer from './orders/universalsearch';
import dumpReducer from './dump'; // Import the Dump reducer
import formReducer from './orders/prescription'
import roomsReducer from './roomsSlice';
import userConfigReducer from './userconfigslice'
import userPrivilegesReducer from './userPrivileges'
import ordersReducer from './orders/ordersSlice'
import ordersDataReducer from './orders/ordersdataSlice';
import toastReducer from './toastslice'; 
const store = configureStore({
  reducer: {
    filter: filterReducer,              // Add filter slice to the store
    universalsearcher: universalsearcherReducer,
    appinfo: appointmentinfo,
    dump: dumpReducer,            
    form: formReducer,
    rooms: roomsReducer,
     userconfig: userConfigReducer,
      userPrivileges: userPrivilegesReducer,
       orders: ordersReducer,
     ordersData: ordersDataReducer,//notusing
     toast: toastReducer,
  },
});

export default store;
